export default __webpack_public_path__ + "static/media/webb.a8233e31.svg";